/* RESPONSIBLE TEAM: team-inbox-management */
export default function isActiveElementAnInput() {
  let { tagName, contentEditable } = document.activeElement as HTMLElement;

  return (
    tagName?.toLowerCase() === 'input' ||
    tagName?.toLowerCase() === 'textarea' ||
    contentEditable === 'true'
  );
}
